import React, { ComponentPropsWithRef, ReactElement } from 'react';
import classnames from 'classnames';
import { FormGroup, FormGroupText } from '../FormGroup';
import { Tooltip, TooltipPosition } from '../../../Tooltip';
import { Icon } from '../Icon';

export type TextfieldProps = ComponentPropsWithRef<'input'> & {
  error?: string;
  horizontal?: boolean;
  label?: string;
  labelClass?: string;
  required?: boolean;
  tooltipText?: string;
  tooltipPosition?: TooltipPosition;
};

export function Textfield({
  className,
  error,
  horizontal = true,
  id,
  label,
  labelClass,
  required,
  tooltipText,
  tooltipPosition = 'down',
  ...rest
}: TextfieldProps): ReactElement {
  const classes = classnames({ error });

  return (
    <FormGroup
      horizontal={horizontal}
      errors={error ? [error] : []}
      className={className}
    >
      <FormGroupText>
        <label className={labelClass} htmlFor={id}>
          {label} {required && '*'}
          {tooltipText && (
            <Tooltip
              position={tooltipPosition}
              id={`${label}-tooltip`}
              text={tooltipText}
              size="medium"
              className="half-margin-left"
            >
              <Icon name="info-outline" />
            </Tooltip>
          )}
        </label>
        <input id={id} type="text" className={classes} {...rest} />
      </FormGroupText>
    </FormGroup>
  );
}
